export const uiFa = {
  close: 'بستن',
  tableScroll: 'جدول؛ برای پیمایش از کلیدهای جهت استفاده کنید',
  loading: 'در حال بارگذاری…',
  active: 'فعال',
  inactive: 'غیرفعال',
  previous: 'قبلی',
  next: 'بعدی',
  page: 'صفحه',
  of: 'از',
  cancel: 'انصراف',
  confirm: 'تأیید',
  brand: 'اوچال',
  slogan: 'نمادی از کیفیت',
  breadcrumbs: 'مسیر صفحه',
  datePicker: {
    hasActivity: 'دارای فعالیت ثبت‌شده',
    months: [
      'فروردین',
      'اردیبهشت',
      'خرداد',
      'تیر',
      'مرداد',
      'شهریور',
      'مهر',
      'آبان',
      'آذر',
      'دی',
      'بهمن',
      'اسفند',
    ],
    weekdays: ['ش', 'ی', 'د', 'س', 'چ', 'پ', 'ج'],
    placeholder: '۱۴۰۵/۰۱/۰۱',
    required: 'انتخاب تاریخ الزامی است.',
    invalid: 'تاریخ شمسی معتبر وارد کنید.',
    outsideRange: 'تاریخ انتخاب‌شده خارج از بازه مجاز است.',
    reversedRange: 'تاریخ پایان نباید قبل از تاریخ شروع باشد.',
    open: 'بازکردن تقویم',
    clearField: 'پاک‌کردن',
    dialog: 'تقویم',
    nextMonth: 'ماه بعد',
    previousMonth: 'ماه قبل',
    today: 'امروز',
    clear: 'پاک‌کردن',
    from: 'از تاریخ',
    to: 'تا تاریخ',
  },
} as const;
